import React, { useCallback, useState } from 'react'
import History from '../../Components/History'
import { MOCK_USER_HISTORY } from '../../mock'
import styles from '../../../CSS/main.css'
import { ButtonActive, ButtonIcon } from '../../Components/Button/Button'
import { useNavigation } from '../../utils/navigation'
import Page from '../../Components/Page'
import { PortalType, SlotPortal } from '../../Components/Portal'
import Breadcrumbs from '../../Components/Breadcrumbs'
import Box from '../../Components/Box'
import classNames from 'classnames'
import ListTabs from '../../../../admin/App/Components/List/ListTabs'
import { Col, ColInfo, ColOptions, ColPhoto, ColSelect, ColStat } from '../../../../admin/App/Components/List/Col'
import Pagination from '../../../../admin/App/Components/Pagination'
import List from '../../../../admin/App/Components/List/List'
import Dropdown from '../../../../admin/App/Components/Dropdown'
import DropdownGroup from '../../../../admin/App/Components/Dropdown/DropdownGroup'
import DropdownItem from '../../../../admin/App/Components/Dropdown/DropdownItem'
import FilterWordsItem from '../../../../admin/App/Components/List/Item/FilterWordsItem'
import { ListParams, useListState } from '../../../../admin/App/Components/List/hooks'
import { FilterWords } from '../../../../admin/App/Components/List/Item/CommentsItem'
import { deleteFilterWords, getFilterWords, updateFilterWords, postFilterWords } from '../../../../admin/App/api/requests'
import { useAsyncCallback } from 'react-async-hook'
import ModalAdd from './ModalAdd'

export type FILTER_STATE = ListParams

export const INIT_FILTER_STATE: FILTER_STATE = {
  page: 1,
  tab: null,
  searchTerm: '',
  sort: null,
}

const FilterWords: React.VFC = () => {
  const { goBack } = useNavigation()
  const {
    params,
    onPageChange,
    select,
    toggleAll,
    selectedItems,
    resetState,
    items,
    pageCount,
    refetch,
    loading,
    allSelected
  } = useListState<FilterWords, FILTER_STATE>(INIT_FILTER_STATE, getFilterWords)
  const { page, tab, searchTerm } = params
  const [open, setOpen] = useState(false)
  const [itemEdit, setItemEdit] = useState<FilterWords| undefined>()

  const onDelete = useCallback(async (ids: ReadonlyArray<string>) => {
    await deleteFilterWords(ids)
    refetch()
  }, [refetch])

  const showModalEdit = useCallback((item: FilterWords) => {
    setItemEdit(item)
    setOpen(true)
  }, [])

  const handleCloseModal = useCallback(() => {
    setOpen(false)
    setItemEdit(null)
  }, [])

  const handleAddEditFilterWords = useCallback(async (forbiddenWord: string) => {
    if (itemEdit) {
      await updateFilterWords(itemEdit.id, forbiddenWord)
      setItemEdit(null)
    } else {
      await postFilterWords(forbiddenWord)
    }

    refetch()
  }, [refetch, itemEdit])

  return (
    <Page>
      <SlotPortal name={PortalType.Toolbar}>
        <Breadcrumbs onBack={goBack} title={'Filter Words'} />
        <div className={classNames([styles.Table, styles.SearchTabs])}>
          <ListTabs
            tabs={[{label: 'All Filter Words', value: 'all'}]}
            activeTab={'all'}
            onChangeTab={null}
          />
          <Col>
            <ButtonIcon
              additionalClassNames={[styles.ButtonAddFilterWord]}
              title='Add Filter Word'
              onClick={() => setOpen(true)}
            />
          </Col>
        </div>
      </SlotPortal>
      <>
          <List 
            items={items}
            itemRenderer={(i) => (
              <FilterWordsItem 
                key={i.id}
                filterWords={{
                  id: i.id,
                  forbiddenWord: i.forbiddenWord
                }}
                onSelected={() => select(i)}
                selected={selectedItems.includes(i)}
                options={
                  <>
                    <DropdownGroup>
                      <DropdownItem onClick={() => onDelete([i.id])}>Delete Forbidden Word</DropdownItem>
                      <DropdownItem onClick={() => showModalEdit(i)}>Edit Forbidden Word</DropdownItem>
                    </DropdownGroup>
                  </>
                }              
              />
            )}
          headerRenderer={() => (
            <>
              <ColSelect
                onChange={toggleAll}
                showActions={!!selectedItems.length}
                toggle={allSelected}>
                <Dropdown
                  trigger={
                    <ButtonIcon
                      title='Select Options'
                      additionalClassNames={[styles.SelectOptions]}
                    />
                  }
                  position={'bottom'}>
                  <DropdownGroup>
                    <DropdownItem onClick={() => onDelete(selectedItems.map(i => i.id))}>Delete selected</DropdownItem>
                  </DropdownGroup>
                </Dropdown>
              </ColSelect>
              <ColPhoto />
              <ColInfo>
                <a href='#'>Forbidden Word</a>
              </ColInfo>
              <ColOptions />
            </>
          )}
        />
        <ModalAdd
          open={open}
          onClose={handleCloseModal}
          textEdit={itemEdit?.forbiddenWord}
          onSuccess={handleAddEditFilterWords}
        />
        <Pagination total={pageCount} page={page} onPageChange={onPageChange}/>
      </>
    </Page>
  )
}

export default FilterWords
